import { render, staticRenderFns } from "./CustomerWantList.vue?vue&type=template&id=18a219e1&scoped=true&"
import script from "./CustomerWantList.vue?vue&type=script&lang=js&"
export * from "./CustomerWantList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerWantList.vue?vue&type=style&index=0&id=18a219e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a219e1",
  null
  
)

export default component.exports